<button type="button" class="btn btn-light btn-menu" (click)="volver()" style="width: 280px;
        height: 45px;
        background-color: #597CEE;
        color: #fff;
        font-weight: bold;
        font-family: 'Montserrat', sans-serif;
        font-size: 15px;
        padding-left: 12px;
        padding-right: 12px;
        border: none;
        border-radius: 0.25em;
        margin-bottom: 30px;">                    
            <span style="color: #FFFFFF;">VOLVER</span>
        </button>

<div>
    <app-reglamento-interno [simulacion]="true" ></app-reglamento-interno>
</div>